/* eslint-disable camelcase, no-undef */

// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'
// eslint-disable-next-line import/no-unresolved
import LZString from 'https://cdn.skypack.dev/lz-string'
const { getElement, getElements, formatMoney, createElement } = window.BAO.Utils

const { useArrows } = window.BAO.Carousel.plugins

const VisualiserURLState = {
  encode (obj) {
    try {
      return LZString.compressToEncodedURIComponent(JSON.stringify(obj))
    } catch (e) {
      return null
    }
  },
  decode (str) {
    try {
      return JSON.parse(LZString.decompressFromEncodedURIComponent(str))
    } catch (e) {
      return null
    }
  },
  read () {
    const params = new URLSearchParams(window.location.search)
    const build = params.get('b')
    return build ? this.decode(build) : null
  },
  push (state) {
    const encoded = this.encode(state)
    if (!encoded) return
    const params = new URLSearchParams(window.location.search)
    params.set('b', encoded)
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${params.toString()}${window.location.hash}`,
    )
  },
}

class earVisualiser extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.visualiser = {
      canvas: {},
      collections: {},
      products: [],
    }

    this.evCanvas = new EVCanvas()

    this._buildState = VisualiserURLState.read()
    this._prefilling = !!this._buildState

    this.canvas = getElement(this.selectors.canvas, { context: this })

    this.currentStep = this._buildState?.st
      ? this._buildState.st
      : this._buildState
        ? 2
        : 1
    this.currentStage = this._buildState ? 'earrings' : 'photo'
    this.activeStage = this._buildState ? 'earrings' : null

    this.productFilter = document.querySelectorAll(
      this.selectors.productFilter,
    )[0]?.dataset.material

    this.summary = true
    this.appointmentDrawer = true

    if (this._buildState) {
      this._prefillFromBuildState()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.selectors = {
      canvas: '[data-visualiser-canvas]',
      next_step: '[data-visualiser-next-step]',
      stage: '[data-visualiser-stage]',
      stage_show: '[data-visualiser-stage-show]',
      stage_value: '[data-visualiser-stage-value]',
      close: '[data-visualiser-close]',
      info: '[data-visualiser-info]',
      info_next: '[data-visualiser-info-next]',
      info_previous: '[data-visualiser-info-previous]',
      info_slider: '[data-visualiser-info-slider]',
      info_slide: '[data-visualiser-info-slide]',
      info_hide: '[data-visualiser-info-hide]',
      backdrop: '[data-visualiser-backdrop]',
      addAllToCart: '[data-visualiser-add-all-to-cart]',
      photo: '[data-visualiser-photo]',
      placement: '[data-visualiser-placement]',
      placement_confirm: '[data-visualiser-placement-confirm]',
      earring_confirm: '[data-visualiser-earring-confirm]',
      earrings_placement_collection:
        '[data-visualiser-earrings-placement-collection]',
      earrings_placement: '[data-visualiser-earrings-placement]',
      earrings_placement_selected:
        '[data-visualiser-earrings-placement][aria-selected="true"]',
      charm_switcher: '[data-visualiser-charm-switcher]',
      back_button: '[data-visualiser-back-button]',
      collection_null: '[data-visualiser-collection-null]',
      collection: '[data-visualiser-collection]',
      products: '[data-visualiser-products]',
      products_inner: '[data-visualiser-products-inner]',
      summary: '[data-visualiser-summary]',
      summary_button: '[data-visualiser-summary-button]',
      summary_button_price: '[data-visualiser-summary-button-price]',
      summary_close: '[data-visualiser-summary-close]',
      summary_edit: '[data-visualiser-summary-edit]',
      appointment_toggle: '[data-visualiser-appointment-toggle]',
      feeling_lucky: '[data-visualiser-feeling-lucky]',
      saveForLater: '[data-visualiser-saveForLater]',
      bookAppointmentSummary: '[data-visualiser-bookAppointmentSummary]',
      reset: '[data-visualiser-reset]',
      preview: '[data-visualiser-preview]',
      step: '[data-visualiser-step]',
      step_summary: '[data-visualiser-step-summary]',
      copy_link: '[data-visualiser-copy-link]',
      bottomInfo: '[data-visualiser-bottomInfo]',
      bottomInfoPlacement: '[data-visualiser-bottomInfoPlacement]',
      breadcrumb: '[data-visualiser-breadcrumb]',
      product_list_header: '[data-visualiser-product-list-header]',
      product_list: '[data-visualiser-product-list]',
      collection_list: '[data-visualiser-collection-list]',
      charm_max: '[data-visualiser-charm-max]',
      placeholder: '[data-visualiser-placeholder]',
      product: '[data-visualiser-product]',
      infoShow: '[data-visualiser-info-show]',
      productFilter: '[data-visualiser-product-filter]',
      add_to_cart: '[data-summary-add-to-cart]',
      summary_book_appointment: '[data-summary-book-appointment]',
      book_appointment: '[data-visualiser-book-appointment]',
    }

    this.handleClick = this.handleClick.bind(this)
    this.listeners.add(this, 'click', this.handleClick)

    this.listeners.add(
      getElement(this.selectors.addAllToCart, { context: this }),
      'click',
      () => {
        EVSummary.addAllToCart(this.visualiser, this)
      },
    )

    this.listeners.add(document, 'visualiser:remove', e => {
      this.updateProducts(e.detail.placement, 'remove')
      if (e.detail.placement === this.placement) {
        this.updateProductsSelected(e.detail.placement)
      }
    })

    this.listeners.add(document, 'browser-back:click', e => {
      if (this.currentStep <= 1) {
        e.preventDefault()
        window.location.href = window.routes.rootUrl
        return
      }

      e.preventDefault()
      this.currentStep--
      VisualiserURLState.push(this._serializeBuildState())
    })
  }

  handleClick (e) {
    if (e.target.closest(this.selectors.next_step)) {
      this.currentStep++
      this._pushBuildState()
    }

    if (e.target.closest(this.selectors.stage_show)) {
      const trigger = e.target.closest(this.selectors.stage_show)

      if (trigger.ariaDisabled !== 'true') {
        const stage = trigger.dataset.stage.split(',')[0]
        this.currentStage = stage
        this.activeStage = stage
      }
    }

    if (e.target.closest(this.selectors.info_hide)) {
      this.infoSlide = ''
    }

    if (e.target.closest(this.selectors.close)) {
      this.activeStage = null
    }

    if (e.target.closest(this.selectors.backdrop)) {
      this.activeStage = null
    }

    if (e.target.closest(this.selectors.photo)) {
      const trigger = e.target.closest(this.selectors.photo)
      const placementObj = JSON.parse(trigger.dataset.placements)

      this.defaultPlacements = placementObj
      this.photo = trigger.dataset.image
      this.activeStage = null

      this._updateAvailablePlacementsUI()

      // Photo added
      this.render(true)
    }

    if (e.target.closest(this.selectors.placement)) {
      const trigger = e.target.closest(this.selectors.placement)
      const handle = trigger.dataset.handle

      trigger.ariaSelected = trigger.ariaSelected !== 'true'

      const placement = this.visualiser.canvas.placements.findIndex(
        placement => placement.name === handle,
      )
      this.visualiser.canvas.placements[placement].available =
        trigger.ariaSelected === 'true'

      this._updateAvailablePlacementsUI()

      this.updatePlacements()
      this.updateProducts(handle, 'remove')
      this._pushBuildState()
    }

    if (e.target.closest(this.selectors.placement_confirm)) {
      this._confirmPlacements()
    }

    if (e.target.closest(this.selectors.earring_confirm)) {
      this._confirmPlacements(true)
    }

    if (
      e.target.closest(this.selectors.earrings_placement_collection) ||
      e.target.closest(this.selectors.earrings_placement_selected)
    ) {
      const trigger = e.target.closest(
        this.selectors.earrings_placement_collection,
      )
      const triggerParent = e.target.closest(this.selectors.earrings_placement)

      this.newCollections = triggerParent.dataset.new.split(',')
      this.healedCollections = triggerParent.dataset.healed.split(',')
      this.collectionType =
        trigger?.dataset?.type || triggerParent?.dataset?.type || 'healed'
      this.placement = triggerParent
      this.updateProductsSelected(this.placement)

      this.currentStage = 'earrings_collection'
      this.activeStage = 'earrings_collection'
    }

    if (e.target.closest(this.selectors.charm_switcher)) {
      const trigger = e.target.closest(this.selectors.charm_switcher)
      this.collectionType = trigger.dataset.type
    }

    if (e.target.closest(this.selectors.back_button)) {
      this.currentStage = 'earrings'
      this.activeStage = 'earrings'
    }

    if (e.target.closest(this.selectors.collection)) {
      const trigger = e.target.closest(this.selectors.collection)
      this.collection = trigger.dataset.handle
    }

    if (e.target.closest(this.selectors.collection_null)) {
      this.collection = null
    }

    if (e.target.closest(this.selectors.infoShow)) {
      e.preventDefault()
      e.stopPropagation()

      const trigger = e.target.closest(this.selectors.infoShow)
      this.infoSlide = trigger.dataset.handle
    }

    if (e.target.closest(this.selectors.productFilter)) {
      const trigger = e.target.closest(this.selectors.productFilter)
      this.productFilter = trigger.dataset.material
    }

    if (
      e.target.closest(this.selectors.product) &&
      !e.target.closest(this.selectors.infoShow)
    ) {
      const trigger = e.target.closest(this.selectors.product)
      const currentPlacement = this.placement

      if (trigger.classList.contains('ear-Charms_Product-selected')) {
        // If the product is already selected, remove it
        this.updateProducts(currentPlacement, 'remove')
        this.updateProductsSelected(currentPlacement)
      } else {
        const object = JSON.parse(
          getElement('.ear-Charms_Object', {
            context: trigger,
          }).innerText,
        )[0]

        if (object.has_post_group || object.has_variants) {
          this.showQuickAddDrawer(object, currentPlacement)
          return
        }

        object.placement = currentPlacement

        this.updateProducts(object, 'add')
        this.updateProductsSelected(currentPlacement)
      }
    }

    if (e.target.closest(this.selectors.add_to_cart)) {
      const trigger = e.target.closest(this.selectors.add_to_cart)
      const index = trigger.dataset.index
      EVSummary.addToCart(this.visualiser, this, index)
    }

    if (e.target.closest(this.selectors.summary_button)) {
      const trigger = e.target.closest(this.selectors.summary_button)

      if (!trigger.disabled) {
        this.summary = false
      }
    }

    if (e.target.closest(this.selectors.summary_close)) {
      this.summary = true
      this.currentStage = 'earrings'
      this.activeStage = 'earrings'
    }

    if (e.target.closest(this.selectors.summary_edit)) {
      const trigger = e.target.closest(this.selectors.summary_edit)
      const triggerParent = getElements(this.selectors.earrings_placement, {
        context: this,
      })?.find(el => el.dataset.handle === trigger.dataset.placement)

      this.newCollections = triggerParent.dataset.new.split(',')
      this.healedCollections = triggerParent.dataset.healed.split(',')

      this.collectionType = trigger?.dataset?.type || 'healed'
      this.placement = triggerParent
      this.updateProductsSelected(this.placement)

      this.summary = true
      this.currentStage = 'earrings_collection'
      this.activeStage = 'earrings_collection'
    }

    if (e.target.closest(this.selectors.appointment_toggle)) {
      this.appointmentDrawer = !this.appointmentDrawer
    }

    if (e.target.closest(this.selectors.copy_link)) {
      navigator.clipboard.writeText(window.location.href)
    }

    if (e.target.closest(this.selectors.feeling_lucky)) {
      this.feelingLucky()
    }

    if (e.target.closest(this.selectors.saveForLater)) {
      const listConfig = {
        lname: 'My Ear Stack',
      }
      window._swat.createList(
        listConfig,
        newList => this.addToWishlist(newList.lid),
        this.wishlistError,
      )
    }

    if (
      e.target.closest(this.selectors.bookAppointmentSummary) ||
      e.target.closest(this.selectors.summary_book_appointment)
    ) {
      this.summary = true
      this.appointmentDrawer = false
    }

    if (e.target.closest(this.selectors.reset)) {
      this.evCanvas.reset(this.canvas, this.visualiser)
    }

    if (e.target.closest(this.selectors.preview)) {
      const trigger = e.target.closest(this.selectors.preview)

      trigger.ariaSelected = trigger.ariaSelected !== 'true'
      this.evCanvas.isPreview = trigger.ariaSelected === 'true'
    }
  }

  async loadCollection (collection) {
    const productList = await this.fetchPage(collection, 1)
    const totalPages = parseInt(productList.dataset.totalPages) || 1

    if (totalPages > 1) {
      const remainingPages = Array.from(
        { length: totalPages - 1 },
        (_, i) => i + 2,
      )
      const remainingLists = await Promise.all(
        remainingPages.map(n => this.fetchPage(collection, n)),
      )
      remainingLists.forEach(list => {
        if (list) productList.innerHTML += list.innerHTML
      })
    }

    const container = getElement(
      `[data-visualiser-collection-list][data-handle='${collection}']`,
    )
    const element = getElement(`[data-visualiser-products]`, {
      context: container,
    })
    const elementInner = getElement(`[data-visualiser-products-inner]`, {
      context: container,
    })
    const filterContainer = getElement(`[data-visualiser-products-filters]`, {
      context: container,
    })

    elementInner.innerHTML = productList.outerHTML
    element.ariaBusy = false

    getElement('.ear-Charms_FilterTextActive', {
      context: container,
    }).innerHTML = ''
    this.buildFilters(filterContainer, productList)

    const collectionListEl = getElements(this.selectors.collection_list, {
      context: this,
    }).find(el => el.dataset.handle === collection)

    if (collectionListEl) {
      const selectedFilter = getElement('.ear-Charms_FilterIcon-selected', {
        context: collectionListEl,
      })
      const firstFilter = getElement('.ear-Charms_FilterIcon', {
        context: collectionListEl,
      })
      this.productFilter = selectedFilter
        ? selectedFilter.dataset.material
        : firstFilter.dataset.material
    }
  }

  async fetchPage (collection, page) {
    const response = await fetch(
      `/collections/${collection}?sections=ear-visualiser-collection&page=${page}`,
    )
    const json = await response.json()
    const parsedHtml = new DOMParser().parseFromString(
      json['ear-visualiser-collection'],
      'text/html',
    )

    const products = parsedHtml.querySelector('.ear-Charms_ProductList')

    return products
  }

  buildFilters (filterContainer, productList) {
    filterContainer.innerHTML = ''

    const filterEls = productList.querySelectorAll('[data-visualiser-product]')

    const uniqueByMaterial = new Map(
      [...filterEls].map(p => [
        p.dataset.charmMaterial,
        {
          name: p.dataset.charmMaterial,
          hex: p.dataset.charmHex,
          hexSecondary: p.dataset.charmHexSecondary,
        },
      ]),
    )
    const hexOrder = ['#ffcc8b', '#d9d9d9', '#f0c7a4']
    const filters = [...uniqueByMaterial.values()].sort((a, b) => {
      const ai = hexOrder.indexOf(a.hex.toLowerCase())
      const bi = hexOrder.indexOf(b.hex.toLowerCase())
      return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi)
    })

    filters.forEach(filter => {
      let style = `--background-color: ${filter.hex};`
      if (filter.hexSecondary && filter.hex !== filter.hexSecondary) {
        style = `--background-color-primary: ${filter.hex}; --background-color-secondary: ${filter.hexSecondary};`
      }

      const classList = `ear-Charms_FilterIcon${
        filter.hexSecondary ? ' ear-Charms_DualSwatch' : ''
      }`

      const filterItem = createElement('div', {
        class: classList,
        'data-visualiser-product-filter': '',
        'data-material': filter.name,
        style,
      })

      const span = createElement('span', {
        class: 'util-ScreenReaderOnly',
        innerText: filter.name,
      })

      filterContainer.append(filterItem)
      filterItem.append(span)
    })
  }

  async showQuickAddDrawer (product, placement) {
    const drawer = document.querySelector(
      'site-drawer[key="visualiser-post-select"]',
    )
    if (!drawer) return

    const body = drawer.querySelector('.drw-Drawer_Body')
    if (!body) return

    // Reset any post-price addon left by a previously opened drawer before the
    // quick-add components re-prime it on connect.
    document.body.dataset.postPriceAddon = '0'

    body.innerHTML = await window.BAO.Caches.quickAddCache.get(product.handle)

    const inner = body.querySelector('.prd-QuickAdd_Inner')
    if (!inner) return

    // Strip elements that don't belong in the visualiser: metal/plating
    // swatches and the view-product link navigate away; the delivery note and
    // cart icon are cart-specific. Marked with data-visualiser-strip in the
    // quick-add markup so classname changes don't silently break this.
    inner.querySelectorAll('[data-visualiser-strip]').forEach(el => el.remove())

    // The footer's top border only makes sense paired with the delivery note.
    const footer = inner.querySelector('.prd-QuickAdd_Footer')
    if (footer) footer.style.borderBlockStart = 'none'

    const form = inner.querySelector('form')
    const addButton = inner.querySelector('[data-product-add-to-cart]')
    const addButtonText = inner.querySelector('[data-product-add-to-cart-text]')
    const postVariantInput = inner.querySelector(
      '[data-product-post-el="variant-id"]',
    )

    // Override the data attributes so product-quick-add-post.js uses the
    // visualiser confirm label rather than "Add to bag" / "Please select a post size".
    const confirmText = this.dataset.confirmText || 'Confirm'
    if (addButton) {
      addButton.dataset.addToCartText = confirmText
      addButton.dataset.postPendingText = confirmText
    }
    if (addButtonText) addButtonText.textContent = confirmText

    const basePrice = product.price

    const getMainPrice = () => {
      const mainId = form?.querySelector('[name="id"]')?.value
      const variantsScript = inner.querySelector(
        '[data-variant-radios-el="data"]',
      )
      if (variantsScript && mainId) {
        const variant = JSON.parse(variantsScript.textContent).find(
          v => String(v.id) === String(mainId),
        )
        if (variant) return variant.price
      }
      return basePrice
    }

    // Disable the button until all required selections are made: a post size
    // (when the product has a post group) and an earring variant (when the
    // product has multiple variants). product-quick-add-post.js handles the
    // post side; this covers the earring variant side.
    const variantRadios = inner.querySelector('variant-radios')
    const updateAddState = () => {
      if (!addButton) return
      const postReady = postVariantInput ? !!postVariantInput.value : true
      const variantReady = variantRadios ? !!variantRadios.currentVariant : true
      addButton.disabled = !(postReady && variantReady)
    }
    updateAddState()
    inner.addEventListener('change', updateAddState)

    // Intercept the cart submit (capture phase, before product-form.js's
    // listener on the form) and add to the visualiser instead of the cart.
    inner.addEventListener(
      'submit',
      e => {
        e.preventDefault()
        e.stopImmediatePropagation()

        const mainId = form?.querySelector('[name="id"]')?.value
        if (!mainId) return
        if (postVariantInput && !postVariantInput.value) return

        const postAddon = Number(document.body.dataset.postPriceAddon) || 0

        product.variant_id = Number(mainId)
        if (postVariantInput?.value) {
          product.post_variant_id = Number(postVariantInput.value)

          const checkedPost = inner.querySelector(
            '[data-quick-add-post-el="post-radio"]:checked',
          )
          // VennApps needs the post line's product id for storefront API lookups.
          if (checkedPost) product.post_product_id = Number(checkedPost.value)
          const backing = checkedPost
            ? inner
              .querySelector(
                  `label[for="${checkedPost.id}"] .prd-QuickAdd_VariantTitle`,
              )
              ?.textContent.trim()
            : ''
          const size = inner
            .querySelector('[data-quick-add-post-el="size-select"]')
            ?.selectedOptions[0]?.textContent.trim()

          const parts = []
          if (size) parts.push(`Post Size: ${size}`)
          if (backing) parts.push(`Backing: ${backing}`)
          product.post_summary = parts.join(', ')
        }
        product.price = getMainPrice() + postAddon
        product.placement = placement

        this.updateProducts(product, 'add')
        this.updateProductsSelected(placement)

        if (window.drawers) window.drawers.close()
      },
      true,
    )

    if (window.drawers) window.drawers.open('visualiser-post-select')
  }

  addToWishlist (lid) {
    this.visualiser.products.forEach(product => {
      const productObj = {
        epi: parseInt(product.variant_id),
        empi: parseInt(product.id),
        du: product.url,
      }

      window._swat.addToList(
        lid,
        productObj,
        this.AddedToWishlist.bind(this),
        this.wishlistError,
      )
    })
  }

  AddedToWishlist () {
    const element = getElement(this.selectors.saveForLater, { context: this })
    const preText = element.innerHTML
    element.innerHTML = element.dataset.addedText

    setTimeout(() => {
      element.innerHTML = preText
    }, 2000)
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`, errorMessage)
  }

  getRandomInt (max, exclude) {
    let rand
    do {
      rand = Math.floor(Math.random() * max)
      // eslint-disable-next-line no-unmodified-loop-condition
    } while (rand === exclude && max > 1)
    return rand
  }

  feelingLucky () {
    const json = JSON.parse(this.dataset.feelingLucky)
    const randomIndex = this.getRandomInt(json.length, this.lucky)
    this.lucky = randomIndex
    const products = json[randomIndex]

    if (products.length === 0) {
      this.lucky = null
      return
    }

    const filteredProducts = products.filter(product => {
      const findPlacement = this.visualiser.canvas.placements.find(
        placement => {
          return placement.name === product.placement
        },
      )
      return product.id !== null && findPlacement.available
    })

    const lastProduct = filteredProducts.pop()

    if (filteredProducts) {
      this.visualiser.products = filteredProducts.map(product => {
        let object
        const productCard = getElement(`[data-product-id="${product.id}"]`, {
          context: this,
        })
        if (productCard) {
          object = JSON.parse(
            getElement('.ear-Charms_Object', {
              context: productCard,
            }).innerText,
          )[0]

          object.placement = product.placement
          object.placement_name = product.placement_full_name
        }

        return object
      })
    }

    if (lastProduct) {
      const lastProductCard = getElement(
        `[data-product-id="${lastProduct.id}"]`,
        { context: this },
      )
      if (lastProductCard) {
        const lastProductObject = JSON.parse(
          getElement('.ear-Charms_Object', {
            context: lastProductCard,
          }).innerText,
        )[0]

        lastProductObject.placement = lastProduct.placement

        this.updateProducts(lastProductObject, 'add')
      }
    }
  }

  updateProductsSelected (placement) {
    const currentProduct = this.visualiser.products.find(
      product => product.placement === placement,
    )
    document.querySelectorAll(this.selectors.product).forEach(product => {
      const isSelected =
        currentProduct?.id === parseInt(product.dataset.productId)
      product.classList.toggle('ear-Charms_Product-selected', isSelected)

      // Mirror the chosen post/size beneath the card title, but only on the
      // card selected for this placement.
      const content = product.querySelector('.ear-Charms_ProductContent')
      if (!content) return

      const priceEl = content.querySelector('.ear-Charms_ProductPrice')

      let meta = content.querySelector('.ear-Charms_ProductMeta')
      if (isSelected && currentProduct?.post_summary) {
        if (!meta) {
          meta = document.createElement('p')
          meta.className = 'ear-Charms_ProductMeta fz-11_17'
          content.insertBefore(meta, priceEl)
        }
        meta.textContent = currentProduct.post_summary
      } else if (meta) {
        meta.remove()
      }

      // Reflect the chosen post/size price on the card so it matches the
      // summary and cart; restore the server-rendered price when deselected.
      if (priceEl) {
        if (priceEl.dataset.basePriceText === undefined) {
          priceEl.dataset.basePriceText = priceEl.textContent.trim()
        }
        priceEl.textContent =
          isSelected && currentProduct?.price != null
            ? `+${formatMoney(currentProduct.price)}`
            : priceEl.dataset.basePriceText
      }
    })
  }

  updatePlacements () {
    getElements(this.selectors.earrings_placement).forEach(placement => {
      const matching = this.visualiser.canvas.placements.find(
        obj => obj.name === placement.dataset.handle,
      )
      placement.ariaHidden = !matching.available
    })
  }

  updateStages (type, value, nextStage, objectType) {
    getElements(this.selectors.stage_value, { context: this }).forEach(
      stage => {
        if (stage.dataset.stage === type) {
          stage.classList.toggle('ear-Visualiser_StepValue-active', value)
        }
      },
    )

    getElements(this.selectors.stage_show, { context: this })?.forEach(
      stage => {
        if (stage.dataset.stage === type) {
          stage.dataset.completed = this.visualiser[objectType][type] !== null
        }

        if (nextStage) {
          if (stage.dataset.stage.includes(nextStage)) {
            stage.ariaDisabled = false
          }
        }
      },
    )
  }

  async render (render) {
    if (render) {
      this.visualiser.canvas.previewImage = await this.evCanvas.render(
        this.canvas,
        this.visualiser,
        this.currentStage,
      )
    } else {
      this.visualiser.canvas.previewImage = await this.evCanvas.update(
        this.canvas,
        this.visualiser,
        this.currentStage,
      )
    }

    EVSummary.render(this.visualiser)
  }

  /**
   *
   * @param {*} type
   * @param {*} value
   * @param {*} render
   * @param {*} nextStage
   */
  updateCanvas (type, value, nextStage) {
    this.visualiser.canvas[type] = value

    this.updateStages(type, value, nextStage, 'canvas')
  }

  /**
   *
   * @param {*} value
   */
  async updateProducts (value, action) {
    switch (action) {
      case 'remove': {
        // Remove current product matching the placement
        const placementHandle = value
        const removeProductIndex = this.visualiser.products.findIndex(
          obj => obj.placement === placementHandle,
        )

        if (removeProductIndex !== -1) {
          this.visualiser.products.splice(removeProductIndex, 1)
        }

        break
      }
      case 'add': {
        const placementHandle = value.placement
        const addProductIndex = this.visualiser.products.findIndex(
          obj => obj.placement === placementHandle,
        )
        const matchingPlacement = this.visualiser.canvas.placements.find(
          obj => obj.name === placementHandle,
        )
        // Remove current product matching the placement
        if (addProductIndex !== -1) {
          this.visualiser.products.splice(addProductIndex, 1)
        }

        value.placement = placementHandle
        value.placement_name = matchingPlacement.full_name
        value.type = this.collectionType
        value.collection = this._collection

        this.visualiser.products.push(value)
        break
      }
      case 'clear':
        this.visualiser.products = []
        break
    }

    // Set current count value
    getElements('.ear-Visualiser_StepValue-none', { context: this }).forEach(
      maxValue => {
        maxValue.innerHTML = this.visualiser.products.length
      },
    )

    this._syncPlacementsDOM()

    const total_price = this.visualiser.products.reduce(
      (accumulator, product) => {
        return accumulator + product.price
      },
      0,
    )

    getElements(this.selectors.summary_button_price, {
      context: this,
    })?.forEach(button => {
      button.innerText = `- ${formatMoney(total_price)}`
    })

    // Clearing always precedes an imminent full render(true) for the new
    // photo, so re-rendering the canvas here would just race that rebuild.
    if (action !== 'clear') {
      this.render()
    }

    // Disable/undisable the summary button
    getElements(this.selectors.summary_button, { context: this })?.forEach(
      button => {
        button.disabled = this.visualiser.products.length <= 0
      },
    )

    if (this.selectors.step_summary) {
      getElements(this.selectors.step_summary, { context: this }).ariaHidden =
        this.visualiser.products.length === 0
    }

    this._pushBuildState()
  }

  async _prefillFromBuildState () {
    const build = this._buildState
    if (!build) return

    if (build.ph) {
      const photoEl = getElements(this.selectors.photo, { context: this }).find(
        el => el.dataset.image === build.ph,
      )

      if (photoEl) {
        const placementObj = JSON.parse(photoEl.dataset.placements)
        this.defaultPlacements = placementObj
        this.photo = photoEl.dataset.image

        if (build.pl?.length) {
          build.pl.forEach(buildPlacement => {
            const placement = this.visualiser.canvas.placements.find(
              p => p.name === buildPlacement.n,
            )
            if (placement) {
              placement.available = buildPlacement.a
              const domEl = document.querySelector(
                `.ear-Info_Capsule[data-handle="${buildPlacement.n}"]`,
              )
              if (domEl) domEl.ariaSelected = buildPlacement.a
            }
          })
        }

        const availablePlacements = this.visualiser.canvas.placements.filter(
          p => p.available,
        )
        this.placementButton = availablePlacements.length === 0
        getElement(this.selectors.charm_max, { context: this }).innerHTML =
          availablePlacements.length

        this.updatePlacements()
        this.updateStages('placements', true, 'earrings', 'canvas')

        await this.render(true)
      }
    }

    await this._prefillCharms()
  }

  async _prefillCharms () {
    const build = this._buildState
    if (!build?.pr?.length) {
      this._checkEarBuildComplete()
      return
    }

    for (const buildProduct of build.pr) {
      if (!buildProduct.c) continue

      await this.loadCollection(buildProduct.c)

      const productEl = getElement(`[data-product-id="${buildProduct.id}"]`, {
        context: this,
      })
      if (!productEl) continue

      const object = JSON.parse(
        getElement('.ear-Charms_Object', { context: productEl }).innerText,
      )[0]

      if (buildProduct.vi) object.variant_id = buildProduct.vi

      const matchingPlacement = this.visualiser.canvas.placements?.find(
        p => p.name === buildProduct.pl,
      )
      if (!matchingPlacement) continue

      object.placement = buildProduct.pl
      object.placement_name = matchingPlacement.full_name
      object.type = buildProduct.pt || 'healed'
      object.collection = buildProduct.c

      const existingIndex = this.visualiser.products.findIndex(
        p => p.placement === buildProduct.pl,
      )
      if (existingIndex !== -1) {
        this.visualiser.products.splice(existingIndex, 1)
      }
      this.visualiser.products.push(object)
    }

    this._syncPlacementsDOM()

    getElements(this.selectors.summary_button, { context: this })?.forEach(
      button => {
        button.disabled = this.visualiser.products.length <= 0
      },
    )

    await this.render()

    this._checkEarBuildComplete()
  }

  _checkEarBuildComplete () {
    if (!this._buildState) return

    this._buildState = null
    this._prefilling = false
  }

  _serializeBuildState () {
    return {
      v: 1,
      t: 'ear',
      st: this.currentStep,
      ph: this.visualiser.canvas.photo || null,
      pl: this.visualiser.canvas.placements
        ? this.visualiser.canvas.placements.map(p => ({
          n: p.name,
          a: p.available,
        }))
        : [],
      pr: this.visualiser.products.map(p => ({
        pl: p.placement,
        vi: p.variant_id,
        id: p.id,
        pt: p.type,
        c: p.collection || null,
      })),
    }
  }

  _pushBuildState () {
    if (this._prefilling) return
    VisualiserURLState.push(this._serializeBuildState())
  }

  _updateAvailablePlacementsUI () {
    const available = this.visualiser.canvas.placements.filter(p => p.available)
    this.placementButton = available.length === 0
    getElement(this.selectors.charm_max, { context: this }).innerHTML =
      available.length
  }

  _confirmPlacements (resetCollection = false) {
    this.updateStages('placements', true, 'earrings', 'canvas')
    this.updatePlacements()
    this.currentStage = 'earrings'
    this.activeStage = 'earrings'
    if (resetCollection) this.collection = null
  }

  _syncPlacementsDOM () {
    getElements(this.selectors.earrings_placement, { context: this }).forEach(
      placement => {
        const matching = this.visualiser.products.find(
          product => product.placement === placement.dataset.handle,
        )
        if (matching) {
          getElement('.ear-Info_CapsuleImage', {
            context: placement,
          }).setAttribute('src', matching.preview_image)
          getElement('.ear-Info_CapsuleTitleItem-selectedPrice', {
            context: placement,
          }).innerText = formatMoney(matching.price)
          placement.dataset.type = matching.type
        } else {
          placement.dataset.type = ''
        }
        placement.ariaSelected = matching ? 'true' : 'false'
      },
    )
  }

  /**
   * Change the photo
   */
  get photo () {
    return this._photo
  }

  set photo (url) {
    if (this._photo && this.visualiser.products.length) {
      this.updateProducts(null, 'clear')
    }

    this.updateCanvas('photo', url, 'placements')

    getElements(this.selectors.photo, { context: this })?.forEach(photo => {
      photo.classList.toggle(
        'ear-Info_Square-selected',
        photo.dataset.image === url,
      )

      photo.ariaSelected = photo.dataset.image === url
    })

    this._photo = url

    getElement(this.selectors.placeholder, { context: this }).ariaHidden = true

    this._pushBuildState()
  }

  /**
   * Change the default placements within the object
   */
  get defaultPlacements () {
    return this._defaultPlacements
  }

  set defaultPlacements (json) {
    this.visualiser.canvas.placements = json

    this.visualiser.canvas.placements.forEach(placement => {
      document
        .querySelector(`.ear-Info_Capsule[data-handle="${placement.name}"]`)
        .setAttribute('aria-selected', placement.available)
    })

    this._defaultPlacements = json
  }

  /**
   * Update if the placement button is available or not
   */
  get placementButton () {
    return this._placementButton
  }

  set placementButton (state) {
    getElement(this.selectors.placement_confirm, {
      context: this,
    }).disabled = state

    this._placementButton = state
  }

  /**
   * Show/hide the product information
   */
  get infoSlide () {
    return this._infoSlide
  }

  set infoSlide (productHandle) {
    if (productHandle) {
      fetch(`/products/${productHandle}?sections=ear-visualiser-info`)
        .then(response => response.json())
        .then(responseJSON => {
          getElement('.ear-CharmInfo_Target', {
            context: getElement(this.selectors.info, { context: this }),
          }).innerHTML = responseJSON['ear-visualiser-info']

          getElement(this.selectors.info, { context: this }).ariaHidden =
            productHandle.length <= 0

          const infoStockElement = getElement('[data-info-stock]', {
            context: this,
          })
          if (infoStockElement) {
            infoStockElement.ariaHidden = this.collectionType !== 'new'
          }

          this.initialiseInfoCarousel()
        })
        .catch(e => {
          console.error(e)
        })
    } else {
      getElement(this.selectors.info, { context: this }).ariaHidden =
        productHandle.length <= 0
    }

    this._infoSlide = productHandle
  }

  /**
   * Show/hide the appointment drawer
   */
  get appointmentDrawer () {
    return this._appointmentDrawer
  }

  set appointmentDrawer (hidden) {
    getElement(this.selectors.book_appointment, {
      context: this,
    }).ariaHidden = hidden

    this._appointmentDrawer = hidden
  }

  initialiseInfoCarousel () {
    if (this.selectors.info_slider) {
      return new KeenSlider(
        getElement(this.selectors.info_slider, { context: this }),
        {
          selector: getElements(this.selectors.info_slide),
          loop: true,
          slides: {
            origin: 'center',
            perView: 1,
          },
        },
        [
          carousel => {
            carousel.on('animationStarted', () => {
              const nextActiveIndex = carousel.track.absToRel(
                carousel.animator.targetIdx || 0,
              )

              carousel.slides.forEach((slide, index) => {
                slide.setAttribute('aria-current', index === nextActiveIndex)
              })

              this.activeIndex = nextActiveIndex
            })
          },
          useArrows({
            next: getElement(this.selectors.info_next, { context: this }),
            previous: getElement(this.selectors.info_previous, {
              context: this,
            }),
          }),
        ],
      )
    }
  }

  /**
   * Change current step of the visualiser
   */
  get currentStep () {
    return this._currentStep
  }

  set currentStep (currentStep) {
    getElements(this.selectors.step, { context: this }).forEach(step => {
      step.ariaHidden = parseInt(step.dataset.step) !== currentStep
    })

    this._currentStep = currentStep
  }

  /**
   * Change current stage of the visualiser between material/length/charm etc...
   */
  get currentStage () {
    return this._currentStage
  }

  set currentStage (currentStage) {
    getElements(this.selectors.stage, { context: this }).forEach(stage => {
      stage.ariaHidden = stage.dataset.stage !== currentStage
    })

    getElements(this.selectors.stage_show, { context: this })?.forEach(
      stageShow => {
        stageShow.classList.toggle(
          'ear-Visualiser_Step-active',
          stageShow.dataset.stage.includes(currentStage),
        )
      },
    )

    getElement(this.selectors.bottomInfo, { context: this }).ariaHidden =
      currentStage !== 'earrings' && currentStage !== 'earrings_collection'

    getElement(this.selectors.bottomInfoPlacement, {
      context: this,
    }).ariaHidden = currentStage !== 'placements'

    this.evCanvas.update(this.canvas, this.visualiser, currentStage)

    this._currentStage = currentStage
  }

  /**
   * Change current stage of the visualiser between material/length/charm etc...
   */
  get activeStage () {
    return this._activeStage
  }

  set activeStage (activeStage) {
    getElements(this.selectors.stage, { context: this }).forEach(stage => {
      stage.ariaCurrent = stage.dataset.stage === activeStage
    })

    getElement(this.selectors.backdrop, { context: this }).ariaHidden =
      activeStage === 'earrings' ||
      activeStage === 'earrings_collection' ||
      activeStage === null ||
      activeStage === 'placements'

    getElement('.ear-Visualiser_Steps', { context: this }).ariaHidden =
      activeStage === 'earrings' ||
      activeStage === 'earrings_collection' ||
      activeStage === 'placements'

    this._activeStage = activeStage
  }

  /**
   * Sets the current placement being used
   */
  get placement () {
    return this._placement
  }

  set placement (el) {
    getElement(this.selectors.breadcrumb, { context: this }).innerText =
      el.dataset.name

    this._placement = el.dataset.handle
  }

  /**
   * Set new collections that can be selected
   */
  get newCollections () {
    return this._newCollections
  }

  set newCollections (collections) {
    this.visualiser.collections.new = collections
  }

  /**
   * Set healed collections that can be selected
   */
  get healedCollections () {
    return this._healedCollections
  }

  set healedCollections (collections) {
    this.visualiser.collections.healed = collections
  }

  /**
   * Change product material selected
   */
  get collectionType () {
    return this._collectionType
  }

  set collectionType (type) {
    getElements(this.selectors.charm_switcher, { context: this }).forEach(
      el => {
        el.ariaSelected = el.dataset.type === type
      },
    )

    getElements(this.selectors.collection, { context: this }).forEach(el => {
      el.ariaHidden = !this.visualiser.collections[type].includes(
        el.dataset.handle,
      )
    })

    if (
      window.BAO.Utils.viewportSize() !== 'xs' &&
      window.BAO.Utils.viewportSize() !== 'sm'
    ) {
      const firstAvailableCollection = getElements(this.selectors.collection, {
        context: this,
      }).find(el => {
        return el.ariaHidden === 'false'
      })
      if (firstAvailableCollection) {
        this.collection = firstAvailableCollection.dataset.handle
      }
    }

    this._collectionType = type
  }

  /**
   * Change collection shown of products
   */
  get collection () {
    return this._collection
  }

  set collection (collection) {
    getElements(this.selectors.products, { context: this }).forEach(el => {
      el.ariaBusy = el.dataset.handle !== collection
    })

    getElements(this.selectors.products_inner, { context: this }).forEach(
      el => {
        el.innerHTML = ''
      },
    )

    this.loadCollection(collection)

    getElements(this.selectors.collection, { context: this }).forEach(el => {
      el.ariaSelected = el.dataset.handle === collection
    })

    getElements(this.selectors.collection_list, { context: this }).forEach(
      el => {
        el.ariaHidden = el.dataset.handle !== collection
      },
    )

    getElement(this.selectors.product_list_header, {
      context: this,
    }).ariaHidden = collection !== null ? 'true' : 'false'

    getElement(this.selectors.product_list, { context: this }).ariaHidden =
      collection !== null ? 'false' : 'true'

    this._collection = collection
  }

  /**
   * Charm default filtering
   */
  get productFilter () {
    return this._productFilter
  }

  set productFilter (productFilter) {
    const productFilters = getElements(this.selectors.productFilter)
    const productFiltersMatch = productFilters?.filter(
      filter => filter.dataset.material === productFilter,
    )

    if (productFiltersMatch.length > 0) {
      document
        .querySelectorAll(this.selectors.productFilter)
        .forEach(filter => {
          filter.classList.toggle(
            'ear-Charms_FilterIcon-selected',
            filter.dataset.material === productFilter,
          )
        })

      getElements('.ear-Charms_FilterTextActive', { context: this })?.forEach(
        activeText => {
          activeText.innerHTML = productFiltersMatch[0].dataset.material
        },
      )

      document.querySelectorAll(this.selectors.product).forEach(product => {
        product.ariaHidden = product.dataset.charmMaterial
          ? product.dataset.charmMaterial !== productFilter
          : false
      })
    }

    this._productFilter = productFilter
  }

  /**
   * Summary open
   */
  get summary () {
    return this._summary
  }

  set summary (hidden) {
    if (this.selectors.summary) {
      getElement(this.selectors.summary, { context: this }).ariaHidden = hidden
    }

    getElement('.ear-Visualiser_Column-selectors', {
      context: this,
    }).ariaHidden = !hidden

    this._summary = hidden
  }
}

class EVSummary {
  static renderImage (url) {
    const wrapper = getElement('[data-summary="image-wrapper"]')
    let image = getElement('[data-summary="image"]', { context: wrapper })

    if (!image) {
      image = createElement('img', {
        'data-summary': 'image',
        loading: 'lazy',
        width: 460,
        height: 460,
        alt: wrapper.dataset.summaryImageAlt || '',
      })
      wrapper.appendChild(image)
      wrapper.classList.remove('ear-Summary_Image-skeleton')
    }

    image.src = url
  }

  static render (object) {
    if (object.canvas.previewImage) {
      // Product Image
      EVSummary.renderImage(object.canvas.previewImage)
    }

    // Product charms
    let productsHTML = ``
    object.products.forEach((product, index) => {
      productsHTML += `<div class="ear-Summary_Item">
        <img src="${
          product.preview_image
        }" height="80" width="80" class="ear-Summary_ItemImage" />

        <div class="ear-Summary_ItemBody">
          <div class="ear-Summary_ItemText">
            <p class="ear-Summary_ItemTextTitle fz-14_171">${index + 1}. ${
        product.placement_name
      } - ${
        product.name
      } <span class="ear-Summary_ItemEdit btn-Button btn-Button-underline fz-14_171" data-visualiser-summary-edit data-placement="${
        product.placement
      }" data-type="${product.type}">${theme.strings.bespoke.edit}</span>${
        product.post_summary
          ? `<span class="ear-Summary_ItemMeta fz-11_17">${product.post_summary}</span>`
          : ''
      }</p>

            <p class="ear-Summary_ItemPrice fz-14_171">${formatMoney(
              product.price,
            )}</p>
          </div>

          <div class="ear-Summary_ItemATCWrapper">
            ${
              product.type !== 'new'
                ? `<button class="ear-Summary_ItemATC fz-13_162" data-summary-add-to-cart data-index="${index}">Add to cart</button>`
                : `<button class="ear-Summary_ItemATC fz-13_162" data-summary-book-appointment data-index="${index}">Book Appointment</button>`
            }

            <span class="ear-Summary_ItemCategory fz-11_17">${
              product.type
            } piercing</span>
          </div>
        </div>
      </div>`
    })

    getElement('[data-summary-items]').innerHTML = productsHTML

    // Summary total
    const totalCharmPrice = object.products.reduce(
      (accumulator, currentValue) => {
        if (currentValue.type !== 'new') {
          return accumulator + currentValue.price
        } else {
          return accumulator
        }
      },
      0,
    )

    const healedProducts = object.products.filter(
      product => product.type === 'healed',
    )
    getElement('[data-visualiser-add-all-to-cart]').ariaHidden =
      healedProducts.length === 0

    getElements('[data-summary-total]')?.forEach(total => {
      total.innerHTML = formatMoney(totalCharmPrice)
    })

    getElements('[data-summary-total-count]')?.forEach(total => {
      total.innerHTML = healedProducts.length
    })
  }

  static addAllToCart (object, BV) {
    const items = []

    const healedProducts = object.products.filter(
      product => product.type === 'healed',
    )
    healedProducts.forEach((product, index) => {
      const pairId = product.post_variant_id ? crypto.randomUUID() : undefined
      items.push({
        id: product.variant_id,
        product_id: product.id,
        quantity: 1,
        properties: pairId ? { _post_pair_id: pairId } : undefined,
      })
      if (product.post_variant_id) {
        items.push({
          id: product.post_variant_id,
          product_id: product.post_product_id,
          quantity: 1,
          properties: { _post_pair_id: pairId, _post_child: 'true' },
        })
      }
    })

    window.BAO.Cart.addItem(items)
  }

  static addToCart (object, BV, index) {
    const matchingProduct = object.products[index]

    const pairId = matchingProduct.post_variant_id
      ? crypto.randomUUID()
      : undefined
    const items = []
    const productProps = {
      _position: index + 1,
      ...(pairId ? { _post_pair_id: pairId } : {}),
    }

    items.push({
      id: matchingProduct.variant_id,
      product_id: matchingProduct.id,
      quantity: 1,
      properties: productProps,
    })

    if (matchingProduct.post_variant_id) {
      items.push({
        id: matchingProduct.post_variant_id,
        product_id: matchingProduct.post_product_id,
        quantity: 1,
        properties: { _post_pair_id: pairId, _post_child: 'true' },
      })
    }

    window.BAO.Cart.addItem(items)
  }
}

class EVCanvas {
  async render (canvas, visualiser, currentStage) {
    this._renderToken = (this._renderToken || 0) + 1
    const token = this._renderToken

    this.visualiser = visualiser
    this.currentStage = currentStage

    if (canvas) {
      if (!visualiser.canvas.photo) {
        return
      }

      canvas.classList.add('ear-Visualiser_Canvas-loading')

      // Wait for CSS animation to finish
      await new Promise(resolve => setTimeout(resolve, 200))

      if (token !== this._renderToken) return null

      if (this.stage) this.stage.destroy()

      const maxDimension = Math.max(canvas.offsetWidth, canvas.offsetHeight)

      this.stage = new Konva.Stage({
        container: 'ear-Visualiser_Canvas',
        width: maxDimension,
        height: maxDimension,
        draggable: false,
      })

      this.stage.on('touchstart', () => this.onCanvasTouchStart())
      this.stage.on('touchend', () => this.onCanvasTouchEnd())

      if (window.outerWidth < 768) {
        this.stage.offsetX(maxDimension * 0.125)
        this.stage.offsetY(maxDimension * 0.1)
        this.stage.scale({
          x: 1.2,
          y: 1.2,
        })
      }

      await this.generateEarImage(visualiser)

      await this.generatePlacements(visualiser)

      canvas.classList.remove('ear-Visualiser_Canvas-loading')

      return this.generatePreview()
    }
  }

  async update (canvas, visualiser, currentStage) {
    // Update placements only
    this.visualiser = visualiser
    this.currentStage = currentStage

    this.visualiser.canvas.placements?.forEach(async (placement, index) => {
      const placementGroup = this.stage.findOne(`.${placement.name}`)

      if (!placementGroup) return

      const product = this.visualiser.products.find(
        product => product.placement === placement.name,
      )

      const image = placementGroup.findOne('.product-image')
      const currentImage = placementGroup.getAttr('imageUrl')
      const imgUrl =
        placement.angled && product?.image_angled
          ? product?.image_angled
          : product?.image

      if (currentImage !== imgUrl) {
        if (image) {
          image.destroy()
        }

        if (product) {
          const size = this.stageWidth * 0.8
          const img = await this.createImage(imgUrl)
          const image = new Konva.Image({
            x: 0,
            y: 0,
            image: img,
            width: size,
            height: size,
            offsetX: size / 2,
            offsetY: size / 2,
            name: 'product-image',
            opacity: 1,
            rotation: -placement.rotation,
            listening: false,
          })
          placementGroup.add(image)
          placementGroup.setAttr('imageUrl', imgUrl)

          if (this.activePlacement) {
            const activePlacement = this.activePlacement
            this.onPlacementClick(activePlacement)
            this.onPlacementBlur(activePlacement)
          }

          placementGroup.findOne('.remove-tooltip-hitbox').show()
        } else {
          placementGroup.setAttr('imageUrl', '')
          placementGroup.findOne('.remove-tooltip-hitbox').hide()
        }
      }

      this.updatePlacementDisplay(placement, placementGroup)
    })

    await window.BAO.Utils.sleep(500)

    return this.generatePreview()
  }

  async reset (canvas, visualiser) {
    // Update placements only
    this.visualiser = visualiser

    this.visualiser.canvas.placements?.forEach(async (placement, index) => {
      const placementGroup = this.stage.findOne(`.${placement.name}`)

      if (!placementGroup) return

      const size = this.stageWidth

      const x = (size / 100) * placement.x
      const y = (size / 100) * placement.y

      placementGroup.x(x)
      placementGroup.y(y)
    })

    await window.BAO.Utils.sleep(500)

    return this.generatePreview()
  }

  generatePreview () {
    this.generatingImage = true

    if (!this.stage) return

    const clonedStage = this.stage.clone()

    clonedStage.find('.marker-group').forEach(markerGroup => {
      markerGroup.hide()
    })

    const preview = clonedStage.toDataURL({ mimeType: 'image/jpeg' })

    this.generatingImage = false

    return preview
  }

  async generateEarImage () {
    const earLayer = new Konva.Layer()

    const earImg = await this.createImage(this.visualiser.canvas.photo)

    const earImage = new Konva.Image({
      image: earImg,
      x: 0,
      y: 0,
      width: this.stageWidth,
      height: this.stageWidth,
      draggable: false,
    })

    earLayer.add(earImage)
    this.stage.add(earLayer)
  }

  async generatePlacements () {
    this.placementLayer = new Konva.Layer()
    this.activeLayer = new Konva.Layer()

    await Promise.all(
      this.visualiser.canvas.placements.map((placement, index) =>
        this.generatePlacement(placement, index),
      ),
    )

    this.stage.add(this.placementLayer)
    this.stage.add(this.activeLayer)
  }

  async generatePlacement (placement, index) {
    const size = this.stageWidth

    const x = (size / 100) * placement.x
    const y = (size / 100) * placement.y

    const markerWidth = Math.max(this.stageWidth * 0.014, 9)
    const fontSize = Math.max(markerWidth * 0.9, 9)

    const placementGroup = new Konva.Group({
      x,
      y,
      name: placement.name,
      available: placement.available,
      id: `placement-${placement.name}`,
    })

    const circle = new Konva.Circle({
      radius: markerWidth,
      fill: 'rgba(255, 255, 255, 0.3)',
      stroke: 'rgb(255, 255, 255)',
      strokeWidth: 1,
      name: 'circle',
    })

    const number = new Konva.Text({
      text: index + 1,
      fill: 'rgb(255, 255, 255)',
      align: 'center',
      verticalAlign: 'middle',
      fontSize: markerWidth,
      fontFamily: 'Montserrat, sans-serif',
      x: 0,
      y: 0,
      width: markerWidth * 2,
      height: markerWidth * 2,
      offsetX: markerWidth,
      offsetY: markerWidth - 1,
      name: 'number',
    })

    const moveImage = await this.createImage(
      document.querySelector('.ear-Wrapper').dataset.moveImage,
    )
    const moveSymbol = new Konva.Image({
      x: 0,
      y: 0,
      image: moveImage,
      width: markerWidth * 2,
      height: markerWidth * 2,
      offsetX: markerWidth,
      offsetY: markerWidth,
      opacity: 0,
      name: 'move',
    })

    const addImage = await this.createImage(
      document.querySelector('.ear-Wrapper').dataset.addImage,
    )
    const addSymbol = new Konva.Image({
      x: 0,
      y: 0,
      image: addImage,
      width: markerWidth * 2,
      height: markerWidth * 2,
      offsetX: markerWidth,
      offsetY: markerWidth,
      name: 'add',
    })

    const addHoverImage = await this.createImage(
      document.querySelector('.ear-Wrapper').dataset.addHoverImage,
    )
    const addHoverSymbol = new Konva.Image({
      x: 0,
      y: 0,
      image: addHoverImage,
      width: markerWidth * 2,
      height: markerWidth * 2,
      offsetX: markerWidth,
      offsetY: markerWidth,
      opacity: 0,
      name: 'add-hover',
    })

    const tooltip = new Konva.Text({
      text: `  ${placement.full_name.toUpperCase()}  `,
      fill: '#2B2F2E',
      align: 'center',
      verticalAlign: 'middle',
      fontSize,
      fontFamily: 'Montserrat, sans-serif',
      padding: markerWidth * 0.4,
      x: 0,
      y: 0,
    })

    const tooltipArrow = new Konva.Rect({
      width: markerWidth / 2,
      height: markerWidth / 2,
      fill: '#fff',
      rotation: 45,
      x: tooltip.width() * 0.5,
      y: tooltip.height() - markerWidth / 3,
    })

    const tooltipBackground = new Konva.Rect({
      width: tooltip.width(),
      height: tooltip.height(),
      fill: '#fff',
      x: 0,
      y: 0,
    })

    const tooltipGroup = new Konva.Group({
      name: 'tooltip-group',
      placement: placement.name,
      draggable: false,
      offsetX: tooltip.width() / 2,
      offsetY: tooltip.height() + markerWidth * 1.75,
      listening: false,
      opacity: 0,
    })

    tooltipGroup.add(tooltipArrow)
    tooltipGroup.add(tooltipBackground)
    tooltipGroup.add(tooltip)

    const addTooltip = new Konva.Text({
      text: '  IS THIS A NEW PIERCING?                     ',
      fill: '#fff',
      align: 'center',
      verticalAlign: 'middle',
      fontSize,
      fontFamily: 'Montserrat, sans-serif',
      padding: markerWidth * 0.4,
      x: 0,
      y: 0,
    })

    const addTooltipArrow = new Konva.Rect({
      width: markerWidth / 2,
      height: markerWidth / 2,
      fill: '#2B2F2E',
      rotation: 45,
      x: addTooltip.width() * 0.5,
      y: addTooltip.height() - markerWidth / 3,
    })

    const addTooltipBackground = new Konva.Rect({
      width: addTooltip.width(),
      height: addTooltip.height(),
      fill: '#2B2F2E',
      x: 0,
      y: 0,
    })

    const addTooltipYes = new Konva.Text({
      text: 'YES',
      fill: '#fff',
      fontSize,
      fontFamily: 'Montserrat, sans-serif',
      padding: markerWidth * 0.4,
      x: addTooltip.width() * 0.72,
      piercingType: 'new',
    })

    const addTooltipNo = new Konva.Text({
      text: 'NO',
      fill: '#fff',
      fontSize,
      fontFamily: 'Montserrat, sans-serif',
      padding: markerWidth * 0.4,
      x: addTooltip.width() * 0.85,
      piercingType: 'healed',
    })

    const addTooltipGroup = new Konva.Group({
      name: 'add-tooltip-group',
      placement: placement.name,
      draggable: false,
      offsetX: addTooltip.width() / 2,
      offsetY: addTooltip.height() + markerWidth * 1.75,
    })

    addTooltipGroup.add(addTooltipArrow)
    addTooltipGroup.add(addTooltipBackground)
    addTooltipGroup.add(addTooltip)
    addTooltipGroup.add(addTooltipYes)
    addTooltipGroup.add(addTooltipNo)

    const markerGroup = new Konva.Group({
      name: 'marker-group',
      placement: placement.name,
      draggable: false,
    })
    markerGroup.on('mouseenter', () => this.onPlacementHover(placementGroup))
    markerGroup.on('mouseleave', () => this.onPlacementBlur(placementGroup))
    markerGroup.on('click tap', () => this.onPlacementClick(placementGroup))

    addTooltipYes.on('mouseenter', () => this.onAddHover(addTooltipYes))
    addTooltipYes.on('mouseleave', () => this.onAddBlur(addTooltipYes))
    addTooltipYes.on('click tap', () =>
      this.onAddClick(addTooltipYes, placement.name),
    )
    addTooltipNo.on('mouseenter', () => this.onAddHover(addTooltipNo))
    addTooltipNo.on('mouseleave', () => this.onAddBlur(addTooltipNo))
    addTooltipNo.on('click tap', () =>
      this.onAddClick(addTooltipNo, placement.name),
    )

    markerGroup.add(circle)
    markerGroup.add(number)
    markerGroup.add(moveSymbol)
    markerGroup.add(addSymbol)
    markerGroup.add(addHoverSymbol)
    markerGroup.add(tooltipGroup)

    placementGroup.add(markerGroup)
    placementGroup.add(addTooltipGroup)
    this.placementLayer.add(placementGroup)

    addSymbol.hide()
    addHoverSymbol.hide()
    addTooltipGroup.hide()

    const removeTooltipHitbox = new Konva.Rect({
      name: 'remove-tooltip-hitbox',
      width: markerWidth * 2,
      height: markerWidth * 2,
      x: -markerWidth,
      y: -markerWidth,
    })

    const removeTooltip = new Konva.Text({
      text: `  REMOVE  `,
      fill: '#2B2F2E',
      align: 'center',
      verticalAlign: 'middle',
      fontSize,
      fontFamily: 'Montserrat, sans-serif',
      padding: markerWidth * 0.4,
      x: 0,
      y: 0,
    })

    const removeTooltipArrow = new Konva.Rect({
      width: markerWidth / 2,
      height: markerWidth / 2,
      fill: '#fff',
      rotation: 45,
      x: removeTooltip.width() * 0.5,
      y: removeTooltip.height() - markerWidth / 3,
    })

    const removeTooltipBackground = new Konva.Rect({
      width: removeTooltip.width(),
      height: removeTooltip.height(),
      fill: '#fff',
      x: 0,
      y: 0,
    })

    const removeTooltipGroup = new Konva.Group({
      name: 'remove-tooltip-group',
      placement: placement.name,
      draggable: false,
      offsetX: removeTooltip.width() / 2,
      offsetY: removeTooltip.height() + markerWidth * 1.75,
      listening: false,
      opacity: 0,
    })

    removeTooltipHitbox.on('mouseenter', () =>
      this.onRemoveHover(placementGroup),
    )
    removeTooltipHitbox.on('mouseleave', () =>
      this.onRemoveBlur(placementGroup),
    )
    removeTooltipHitbox.on('click tap', () =>
      this.onRemoveClick(placementGroup),
    )

    removeTooltipGroup.add(removeTooltipArrow)
    removeTooltipGroup.add(removeTooltipBackground)
    removeTooltipGroup.add(removeTooltip)

    placementGroup.add(removeTooltipHitbox)
    placementGroup.add(removeTooltipGroup)

    removeTooltipHitbox.hide()

    if (!placement.available) {
      placementGroup.hide()
    }
  }

  createImage (url) {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.crossOrigin = ''
      image.addEventListener('load', () => resolve(image))
      image.addEventListener('error', error => reject(error))
      image.src = url
    })
  }

  onPlacementHover (placementGroup) {
    if (['photo'].includes(this.currentStage)) return

    const markerGroup = placementGroup.findOne('.marker-group')

    if (markerGroup.getAttr('tooltipOpen')) return

    const circle = markerGroup.findOne('.circle')
    const number = markerGroup.findOne('.number')
    const moveSymbol = markerGroup.findOne('.move')
    const addSymbol = markerGroup.findOne('.add')
    const addHoverSymbol = markerGroup.findOne('.add-hover')
    const tooltip = markerGroup.findOne('.tooltip-group')

    circle.to({
      fill: 'rgba(255, 255, 255, 1)',
      duration: 0.15,
    })
    number.to({
      opacity: 0,
      duration: 0.15,
    })
    moveSymbol.to({
      opacity: 1,
      duration: 0.15,
    })
    addSymbol.to({
      opacity: 0,
      duration: 0.15,
    })
    addHoverSymbol.to({
      opacity: 1,
      duration: 0.15,
    })
    tooltip.to({
      opacity: 1,
      duration: 0.15,
    })
    document.body.style.cursor = 'pointer'

    placementGroup.moveTo(this.activeLayer)
  }

  onPlacementBlur (placementGroup) {
    if (['photo'].includes(this.currentStage)) return

    const markerGroup = placementGroup.findOne('.marker-group')

    if (markerGroup.getAttr('tooltipOpen')) return

    const circle = markerGroup.findOne('.circle')
    const number = markerGroup.findOne('.number')
    const moveSymbol = markerGroup.findOne('.move')
    const addSymbol = markerGroup.findOne('.add')
    const addHoverSymbol = markerGroup.findOne('.add-hover')
    const tooltip = markerGroup.findOne('.tooltip-group')

    circle.to({
      fill: 'rgba(255, 255, 255, 0.2)',
      duration: 0.15,
    })
    number.to({
      opacity: 1,
      duration: 0.15,
    })
    moveSymbol.to({
      opacity: 0,
      duration: 0.15,
    })
    addSymbol.to({
      opacity: 1,
      duration: 0.15,
    })
    addHoverSymbol.to({
      opacity: 0,
      duration: 0.15,
    })
    tooltip.to({
      opacity: 0,
      duration: 0.15,
    })

    document.body.style.cursor = 'default'

    placementGroup.moveTo(this.placementLayer)
  }

  onPlacementClick (placementGroup) {
    if (!['earrings', 'earrings_collection'].includes(this.currentStage)) return

    const markerGroup = placementGroup.findOne('.marker-group')
    const addTooltip = placementGroup.findOne('.add-tooltip-group')

    const activePlacement = this.activePlacement
    if (activePlacement && activePlacement.id() !== placementGroup.id()) {
      this.activePlacement = null
      this.onPlacementClick(activePlacement)
      this.onPlacementBlur(activePlacement)
    }

    const circle = markerGroup.findOne('.circle')
    const addSymbol = markerGroup.findOne('.add')
    const addHoverSymbol = markerGroup.findOne('.add-hover')
    const tooltip = markerGroup.findOne('.tooltip-group')

    const tooltipOpen = markerGroup.getAttr('tooltipOpen')

    circle.to({
      fill: tooltipOpen ? '#fff' : '#2B2F2E',
      stroke: tooltipOpen ? '#fff' : '#2B2F2E',
      duration: 0.15,
    })
    addSymbol.to({
      opacity: tooltipOpen ? 0 : 1,
      rotation: tooltipOpen ? 0 : 45,
      duration: 0.15,
    })
    addHoverSymbol.to({
      opacity: tooltipOpen ? 1 : 0,
      rotation: tooltipOpen ? 0 : 45,
      duration: 0.15,
    })
    tooltip.to({
      opacity: tooltipOpen ? 1 : 0,
      duration: 0.15,
    })

    if (tooltipOpen) {
      addTooltip.hide()
    } else {
      addTooltip.show()
    }

    markerGroup.setAttr('tooltipOpen', !tooltipOpen)

    if (tooltipOpen) {
      placementGroup.moveTo(this.placementLayer)
    } else {
      placementGroup.moveTo(this.activeLayer)
    }

    this.activePlacement = !tooltipOpen ? placementGroup : null
  }

  onAddHover (link) {
    link.textDecoration('underline')
    document.body.style.cursor = 'pointer'
  }

  onAddBlur (link) {
    link.textDecoration('')
    document.body.style.cursor = 'default'
  }

  onAddClick (link, placement) {
    const type = link.getAttr('piercingType')

    const el = document.querySelector(
      `[data-visualiser-earrings-placement][data-handle="${placement}"] [data-type="${type}"]`,
    )

    if (!el) return

    el.click()
  }

  onRemoveHover (placementGroup) {
    if (!['earrings', 'earrings_collection'].includes(this.currentStage)) return

    const tooltip = placementGroup.findOne('.remove-tooltip-group')
    const image = placementGroup.findOne('.product-image')

    tooltip.to({
      opacity: 1,
      duration: 0.15,
    })
    if (image) {
      image.to({
        scaleX: 1.1,
        scaleY: 1.1,
        duration: 0.15,
      })
    }

    document.body.style.cursor = 'pointer'

    placementGroup.moveTo(this.activeLayer)
  }

  onRemoveBlur (placementGroup) {
    if (!['earrings', 'earrings_collection'].includes(this.currentStage)) return

    const tooltip = placementGroup.findOne('.remove-tooltip-group')
    const image = placementGroup.findOne('.product-image')

    tooltip.to({
      opacity: 0,
      duration: 0.15,
    })
    if (image) {
      image.to({
        scaleX: 1,
        scaleY: 1,
        duration: 0.15,
      })
    }

    document.body.style.cursor = 'default'

    placementGroup.moveTo(this.placementLayer)
  }

  onRemoveClick (placementGroup) {
    const hitbox = placementGroup.findOne('.remove-tooltip-hitbox')
    const tooltip = placementGroup.findOne('.remove-tooltip-group')

    hitbox.hide()
    tooltip.to({
      opacity: 0,
      duration: 0.15,
    })

    document.dispatchEvent(
      new CustomEvent('visualiser:remove', {
        detail: { placement: placementGroup.getAttr('name') },
      }),
    )
  }

  updatePlacementDisplay (placement, placementGroup) {
    const image = placementGroup.findOne('.product-image')
    const marker = placementGroup.findOne('.marker-group')
    const number = placementGroup.findOne('.number')
    const moveSymbol = placementGroup.findOne('.move')
    const add = placementGroup.findOne('.add')
    const addHover = placementGroup.findOne('.add-hover')

    const showImages = ['earrings', 'earrings_collection'].includes(
      this.currentStage,
    )
    const showNumbers = ['photo', 'placements'].includes(this.currentStage)
    const showAdd = !showNumbers
    const draggable = ['placements'].includes(this.currentStage)
    const showMarker =
      (['placements'].includes(this.currentStage) || !image) && !this.isPreview
    const showGroup = placement.available

    if (image) {
      if (showImages) {
        image.show()
      } else {
        image.hide()
      }
    }

    if (showNumbers) {
      number.show()
      moveSymbol.show()
    } else {
      number.hide()
      moveSymbol.hide()
    }

    if (showAdd) {
      add.show()
      addHover.show()
    } else {
      add.hide()
      addHover.hide()
    }

    if (showMarker) {
      marker.show()
    } else {
      marker.hide()
    }

    if (showGroup) {
      placementGroup.show()
    } else {
      placementGroup.hide()
    }

    placementGroup.setAttr('draggable', draggable)
  }

  onCanvasTouchStart () {
    if (['photo', 'placements'].includes(this.currentStage)) return

    this.touchTimer = window.setTimeout(() => {
      this.isPreview = true
    }, 500)
  }

  onCanvasTouchEnd () {
    window.clearTimeout(this.touchTimer)

    if (this.isPreview) {
      this.isPreview = false
    }
  }

  get isPreview () {
    return this._isPreview
  }

  set isPreview (isPreview) {
    this._isPreview = isPreview
    this.update(this.canvas, this.visualiser, this.currentStage)
  }

  get stageWidth () {
    return this.stage.width()
  }
}

if (!customElements.get('ear-visualiser')) {
  customElements.define('ear-visualiser', earVisualiser)
}
